import React, { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import { ISegmentOffer } from './type';
import { CREATE_OFFER_URI, DISABLE_OFFER_URI, GET_OFFER_URI, UPDATE_OFFER_URI } from '../../tdsHelper';

const useService = () => {
	const [segmentLabelList, setSegments] = React.useState<{ id: number; label: string }[]>([{ id: 0, label: 'HELLO' }]);
	const [mapValueList, setMapValues] = React.useState<Object>({});
	const { postData } = useContext(AjaxContext);
	const getTDSOfferData = useCallback(
		async ({
			app,
			pageDetails,
			sortDetails,
			filterDetails
		}: {
			app: any;
			pageDetails: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { isGold, appName } = app;
			const response = await postData({
				endpoint: GET_OFFER_URI,
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isGold
				},
				queryParams: {
					appName
				}
			});
			const listData = formatListData({ ...response?.data?.data?.tdsOffers });
			for (let idx = 0; idx < listData.length; idx += 1) listData[idx].index = idx + 1;
			const segmentExp = response?.data?.data?.segmentExp;
			const segments: string[] = Object.keys(segmentExp);
			const segmentList: { id: string; label: string }[] = [];
			const mapValues: {
				segmentExp: { [key: string]: { expName: string } };
			} = {
				segmentExp: response?.data?.data?.segmentExp
			};
			segments.forEach((segment: string) => segmentList.push({ id: segment, label: segment }));
			setSegments(segmentList);
			setMapValues(mapValues);
			const count = response?.data?.data?.tdsOffers?.length;
			return { rowCount: count, data: listData };
		},
		[]
	);

	const requestCreateOffer = useCallback((appName: string, data: ISegmentOffer) => {
		const dataList = [];
		dataList.push(data);
		return postData({
			endpoint: CREATE_OFFER_URI,
			body: { tdsOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateOffer = useCallback((appName: string, data: ISegmentOffer) => {
		return postData({
			endpoint: UPDATE_OFFER_URI,
			body: { tdsOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestDisableOffer = useCallback((appName: string, data: ISegmentOffer) => {
		return postData({
			endpoint: DISABLE_OFFER_URI,
			body: { tdsOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const toggleIsDisabledField = useCallback(async (rowData: ISegmentOffer, history: any, user: any, app: any, showAlert: any) => {
		const data = rowData;
		data.isActive = !data.isActive;

		try {
			const response = await requestDisableOffer(app.appName, { ...data });
			if (response?.status !== 200 || !response?.data?.success) {
				showAlert(response.data.error || 'Error occured while disabling an offer', { type: 'error' });
				history.goBack();
				return;
			}
			showAlert('Offer Disabled');
		} catch (error: any) {
			showAlert(error?.response?.data?.error || 'Error occured while disabling an offer', { type: 'error' });
		}
	}, []);

	return {
		getTDSOfferData,
		requestUpdateOffer,
		requestCreateOffer,
		toggleIsDisabledField,
		segmentLabelList,
		mapValueList
	};
};

export default useService;
